import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import IntroSplash from "../components/IntroSplash";
import { Hero, Social, Studio, Services } from "../components/SectionsA";
import { Bio, PluginCafe, Credits, Contacts, Footer } from "../components/SectionsB";
import { Toaster } from "../components/ui/toaster";
import { NAV } from "../mock";

const HomePage = () => {
  const [active, setActive] = useState("home");

  useEffect(() => {
    const ids = NAV.map((n) => n.id);
    const onScroll = () => {
      const pos = window.scrollY + 120;
      let current = "home";
      for (const id of ids) {
        const el = document.getElementById(id);
        if (el && el.offsetTop <= pos) current = id;
      }
      setActive(current);
    };
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <IntroSplash />
      <Navbar active={active} />
      <main>
        <Hero />
        <Social />
        <Studio />
        <Services />
        <Bio />
        <PluginCafe />
        <Credits />
        <Contacts />
      </main>
      <Footer />
      <Toaster />
    </>
  );
};

export default HomePage;
